<template>
  <div>
    <div v-if="flash.success" class="alert alert-success" role="alert">
      {{ flash.success }}
      <button type="button" class="close" :aria-label="trans('generic.close')" @click="dismissSuccess">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="flash.error" class="alert alert-danger" role="alert">
      {{ flash.error }}
      <button type="button" class="close" :aria-label="trans('generic.close')" @click="dismissError">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="flash.warning" class="alert alert-warning" role="alert">
      {{ flash.warning }}
      <button type="button" class="close" :aria-label="trans('generic.close')" @click="dismissWarning">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import FlashMessages from "@/mixins/FlashMessages"

export default {
    mixins: [FlashMessages],
    computed: {
        flash() {
            return this.$page.props.flash
        },
    },
    methods: {
        dismissSuccess() {
            this.dismissMsg('success')
        },
        dismissError() {
            this.dismissMsg('error')
        },
        dismissWarning() {
            this.dismissMsg('warning')
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
